import React from 'react'

import { Box, BoxProps } from '../Box'
import { useInputStyle } from '../../hooks/useInputStyle'

export interface InputAddonProps extends BoxProps {
  placement?: string
  size?: string
}

const InputAddon = ({ placement = 'left', size = 'md', ...props }) => {
  const _placement = {
    left: {
      mr: '-1px',
      roundedRight: 0,
      borderRightColor: 'transparent',
    },
    right: {
      order: 1,
      roundedLeft: 0,
      borderLeftColor: 'transparent',
    },
  }

  const styleProps = {
    ...useInputStyle({ size, variant: 'outline' }),
    flex: '0 0 auto',
    whiteSpace: 'nowrap',
    bg: 'gray.100',
    ..._placement[placement],
  }

  return <Box {...styleProps} {...props} />
}

export const InputLeftAddon = props => <InputAddon placement="left" {...props} />
export const InputRightAddon = props => <InputAddon placement="right" {...props} />

export default InputAddon
